// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Estedad-v7.3/Estedad-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Estedad-v7.3/Estedad-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Estedad-v7.3/Estedad-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Estedad-v7.3/Estedad-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Estedad-v7.3/Estedad-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Estedad-v7.3/Estedad-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Estedad-v7.3/Estedad-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Estedad-v7.3/Estedad-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Estedad-v7.3/Estedad-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/Estedad-v7.3/Estedad-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/inter/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/inter/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/inter/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/inter/Inter-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/inter/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./fonts/vazirmatn-v16-latin/vazirmatn-v16-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./fonts/noto-nastaliq-urdu-v23-latin/noto-nastaliq-urdu-v23-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./fonts/markazi-text-v28-latin/markazi-text-v28-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./fonts/lalezar-v16-latin/lalezar-v16-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --enabled-input-color: #252525;
  --disabled-input-color: #888888;
  --enabled-input-label-color: #525252;
  --disabled-input-label-color: #a3a3a3;
  --invalid-input-color: #d24247;
  /* --focused-input-color: #6734d6; */
  --focused-input-color: #0080ff;
  --focused-input-bg: #f1f8ff;
  --valid-input-color: green;
  --enabled-icon-color: #777777;
  --root-background-color: #fff;
  --edit-color: #f8e114;
  --sidebar-background-color: #111825;
  --green-800: #007353;
  --green-600: #7cce97;
  --green-500: #b1f0ce;
  --green-400: #e9faf3;
  --red-700: #af233a;
  --red-500: #cf5a6d;
  --red-400: #ec7373;
  --red-200: #f1a2a2;
  --red-100: #fde8e8;

  --enabled-input-border: 2px solid #d4d4d4;
  --disabled-input-border: 2px solid #e5e5e5;
  --invalid-input-border: 2px solid var(--invalid-input-color);
  --focused-input-border: 2px solid var(--focused-input-color);
  --valid-input-border: 2px solid var(--valid-input-color);
  --box-border: 2px solid #e5e5e5;

  --big-text-size: 17px;
  --normal-text-size: 16px;
  --small-text-size: 14px;
  --extra-small-text-size: 13px;
  --super-extra-small-text-size: 12px;

  --extra-small-text-weight: 300;
  --normal-text-weight: 400;
  --big-text-weight: 500;

  --small-text-line-height: 18px;
  --normal-text-line-height: 26px;
  --big-text-line-height: 24px;
  --extra-small-text-line-height: 14px;
  /* #region font styles */
  --fz-10: 1rem;
  --fz-12: 1.2rem;
  --fz-13: 1.3rem;
  --fz-14: 1.4rem;
  --fz-15: 1.5rem;
  --fz-16: 1.6rem;
  --fz-18: 1.8rem;
  --fz-20: 2rem;
  --fz-21: 2.1rem;
  --fz-22: 2.2rem;
  --fz-24: 2.4rem;
  --fz-26: 2.6rem;
  --fz-36: 3.6rem;
  /* #endregion */
}

@font-face {
  font-family: Estedad;
  font-style: normal;
  font-weight: 800;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: Estedad;
  font-style: normal;
  font-weight: 500;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: Estedad;
  font-style: normal;
  font-weight: 400;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: Estedad;
  font-style: normal;
  font-weight: 300;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: Estedad;
  font-style: normal;
  font-weight: 200;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
/* @font-face { font-family: IRANSans; font-style: normal; font-weight: bold; src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.eot"); src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.eot?#iefix") format("embedded-opentype"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.woff2") format("woff2"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.woff") format("woff"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.ttf") format("truetype"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: 500; src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.eot"); src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.eot?#iefix") format("embedded-opentype"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.woff2") format("woff2"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.woff") format("woff"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.ttf") format("truetype"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: 300; src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.eot"); src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.eot?#iefix") format("embedded-opentype"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.woff2") format("woff2"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.woff") format("woff"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.ttf") format("truetype"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: 200; src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.eot"); src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.eot?#iefix") format("embedded-opentype"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.woff2") format("woff2"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.woff") format("woff"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.ttf") format("truetype"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: normal; src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\).eot"); src: url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\).eot?#iefix") format("embedded-opentype"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\).woff2") format("woff2"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\).woff") format("woff"), url("./fonts/iran-sans/IRANSansWeb\\(FaNum\\).ttf") format("truetype"); } */
@font-face {
  font-family: Inter;
  font-style: normal;
  font-weight: bold;

  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
@font-face {
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
}
@font-face {
  font-family: Inter;
  font-style: normal;
  font-weight: 200;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
}
@font-face {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
}
/* Vazirmatn */
@font-face {
  font-family: Vazirmatn;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2");
}

/* Noto Nastaliq Urdu */
@font-face {
  font-family: "Noto Nastaliq Urdu";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___})
    format("woff2");
}

/* Markazi Text */
@font-face {
  font-family: "Markazi Text";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2");
}

/* Lalezar */
@font-face {
  font-family: Lalezar;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2");
}
html,
body {
  width: 100%;
  padding: 0;
  margin: 0;
}
body {
  direction: rtl;
  font-family: Estedad !important;
  overflow-y: scroll;
}
a {
  color: inherit;
  text-decoration: none;
}
*:not(.Toastify__toast-body, body) {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* font-family: inherit !important; */
  font-family: Estedad !important;
}
div:focus-visible {
  outline: none;
}
button,
textarea {
  outline: none;
  border: none;
  background-color: transparent;
}
input[type="radio"] {
  cursor: pointer;
}
input {
  border: none;
  direction: inherit !important;
}
input[type="text"] {
  outline: none;
}
input[type="checkbox"] {
  /* Hide the default checkbox */
  appearance: none;
  width: 25px;
  height: 25px;
  border: 2px solid #777777;
  border-radius: 8px;
  cursor: pointer;
}
input[type="checkbox"]:checked {
  /* background-color: #007bff;  */
  border: none;
  position: relative;
  font-family: Estedad !important;
  background-color: var(--focused-input-color);
}
input[type="checkbox"]:checked::after {
  content: "✓";
  /* color: white; */
  color: #ffffff;
  font-size: 15px;
  font-weight: 1000;
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
}
input[type="checkbox"]:disabled {
  background-color: transparent;
  border: 2px solid var(--disabled-input-label-color) !important;
  cursor: default;
}
input[type="checkbox"]:disabled:checked::after {
  content: "✓"; /* Custom checkmark */
  color: var(--disabled-input-label-color);
  /* border: 2px solid #777777; */
  font-size: 15px;
  font-weight: 1000;
  position: absolute;
  top: 57%;
  left: 50%;
  transform: translate(-50%, -50%);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}
input:disabled {
  cursor: default;
}
.Toastify__toast-body {
  text-align: right;
  font-family: Estedad;
}
.Toastify__toast-container {
  z-index: 10010 !important;
}
.css-1h9z7r5-MuiButtonBase-root-MuiTab-root {
  width: 100%;
}
.css-159ulw2-MuiPaper-root {
  box-shadow: none !important;
}
.forceEn {
  font-family: Inter;
  direction: ltr;
}
.forcePe {
  font-family: Estedad;
  direction: rtl;
}
/* .css-1mqtfgo-MuiFormControlLabel-root {
  width: max-content;
} */

@media all and (max-width: 480px) {
  .Toastify__toast-body {
    font-size: 0.8rem;
  }
}

@keyframes allSystemInAnimation {
  0% {
    /* opacity: 0;
    visibility: hidden; */
    transform: translateX(101%);
  }
  100% {
    /* opacity: 1;
    visibility: visible; */
    transform: translateX(0);
  }
}
@keyframes allSystemOutAnimation {
  0% {
    /* opacity: 1; */
    transform: translateX(0);
  }
  100% {
    /* opacity: 0;
    visibility: hidden; */
    transform: translateX(101%);
  }
}
@keyframes selectedSystemInAnimation {
  0% {
    /* opacity: 0;
    visibility: hidden; */
    transform: translateX(101%);
  }
  100% {
    /* opacity: 1;
    visibility: visible; */
    transform: translateX(0);
  }
}
@keyframes selectedSystemIOutAnimation {
  0% {
    /* opacity: 1; */
    transform: translateX(0);
  }
  100% {
    /* opacity: 0;
    visibility: hidden; */
    transform: translateX(101%);
  }
}
@media all and (max-width: 800px) {
  .Toastify__toast-container--top-right {
    right: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,yCAAyC;EACzC,0CAA0C;EAC1C,4DAA4D;EAC5D,4DAA4D;EAC5D,wDAAwD;EACxD,+BAA+B;;EAE/B,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;;EAEnC,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;;EAEtB,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;;8DAEsE;AACxE;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;;8DAEiE;AACnE;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;;8DAEmE;AACrE;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;;8DAEoE;AACtE;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;;8DAEkE;AACpE;AACA,0vEAA0vE;AAC1vE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,gEAA2D;AAC7D;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gEAA6D;AAC/D;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gEAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gEAAiE;AACnE;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gEAA8D;AAChE;AACA,cAAc;AACd;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,6DAAyF;AAC3F;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,6DAA+F;AACjG;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,6DAAqF;AACvF;AACA;;EAEE,WAAW;EACX,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAE9B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,8DAA8D;EAC9D,eAAe;AACjB;AACA;EACE,YAAY,EAAE,qBAAqB;EACnC,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;;GAEG;;AAEH;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE;yBACqB;IACrB,2BAA2B;EAC7B;EACA;IACE;0BACsB;IACtB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE;yBACqB;IACrB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE;yBACqB;IACrB,2BAA2B;EAC7B;EACA;IACE;0BACsB;IACtB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE;yBACqB;IACrB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[":root {\r\n  --enabled-input-color: #252525;\r\n  --disabled-input-color: #888888;\r\n  --enabled-input-label-color: #525252;\r\n  --disabled-input-label-color: #a3a3a3;\r\n  --invalid-input-color: #d24247;\r\n  /* --focused-input-color: #6734d6; */\r\n  --focused-input-color: #0080ff;\r\n  --focused-input-bg: #f1f8ff;\r\n  --valid-input-color: green;\r\n  --enabled-icon-color: #777777;\r\n  --root-background-color: #fff;\r\n  --edit-color: #f8e114;\r\n  --sidebar-background-color: #111825;\r\n  --green-800: #007353;\r\n  --green-600: #7cce97;\r\n  --green-500: #b1f0ce;\r\n  --green-400: #e9faf3;\r\n  --red-700: #af233a;\r\n  --red-500: #cf5a6d;\r\n  --red-400: #ec7373;\r\n  --red-200: #f1a2a2;\r\n  --red-100: #fde8e8;\r\n\r\n  --enabled-input-border: 2px solid #d4d4d4;\r\n  --disabled-input-border: 2px solid #e5e5e5;\r\n  --invalid-input-border: 2px solid var(--invalid-input-color);\r\n  --focused-input-border: 2px solid var(--focused-input-color);\r\n  --valid-input-border: 2px solid var(--valid-input-color);\r\n  --box-border: 2px solid #e5e5e5;\r\n\r\n  --big-text-size: 17px;\r\n  --normal-text-size: 16px;\r\n  --small-text-size: 14px;\r\n  --extra-small-text-size: 13px;\r\n  --super-extra-small-text-size: 12px;\r\n\r\n  --extra-small-text-weight: 300;\r\n  --normal-text-weight: 400;\r\n  --big-text-weight: 500;\r\n\r\n  --small-text-line-height: 18px;\r\n  --normal-text-line-height: 26px;\r\n  --big-text-line-height: 24px;\r\n  --extra-small-text-line-height: 14px;\r\n  /* #region font styles */\r\n  --fz-10: 1rem;\r\n  --fz-12: 1.2rem;\r\n  --fz-13: 1.3rem;\r\n  --fz-14: 1.4rem;\r\n  --fz-15: 1.5rem;\r\n  --fz-16: 1.6rem;\r\n  --fz-18: 1.8rem;\r\n  --fz-20: 2rem;\r\n  --fz-21: 2.1rem;\r\n  --fz-22: 2.2rem;\r\n  --fz-24: 2.4rem;\r\n  --fz-26: 2.6rem;\r\n  --fz-36: 3.6rem;\r\n  /* #endregion */\r\n}\r\n\r\n@font-face {\r\n  font-family: Estedad;\r\n  font-style: normal;\r\n  font-weight: 800;\r\n  src:\r\n    url(\"./fonts/Estedad-v7.3/Estedad-ExtraBold.woff2\") format(\"woff2\"),\r\n    url(\"./fonts/Estedad-v7.3/Estedad-ExtraBold.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Estedad;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  src:\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Bold.woff2\") format(\"woff2\"),\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Bold.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Estedad;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src:\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Medium.woff2\") format(\"woff2\"),\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Medium.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Estedad;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  src:\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Regular.woff2\") format(\"woff2\"),\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Regular.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Estedad;\r\n  font-style: normal;\r\n  font-weight: 200;\r\n  src:\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Light.woff2\") format(\"woff2\"),\r\n    url(\"./fonts/Estedad-v7.3/Estedad-Light.ttf\") format(\"truetype\");\r\n}\r\n/* @font-face { font-family: IRANSans; font-style: normal; font-weight: bold; src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.eot\"); src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.eot?#iefix\") format(\"embedded-opentype\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.woff2\") format(\"woff2\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.woff\") format(\"woff\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Bold.ttf\") format(\"truetype\"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: 500; src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.eot\"); src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.eot?#iefix\") format(\"embedded-opentype\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.woff2\") format(\"woff2\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.woff\") format(\"woff\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Medium.ttf\") format(\"truetype\"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: 300; src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.eot\"); src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.eot?#iefix\") format(\"embedded-opentype\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.woff2\") format(\"woff2\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.woff\") format(\"woff\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_Light.ttf\") format(\"truetype\"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: 200; src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.eot\"); src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.eot?#iefix\") format(\"embedded-opentype\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.woff2\") format(\"woff2\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.woff\") format(\"woff\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\)_UltraLight.ttf\") format(\"truetype\"); } @font-face { font-family: IRANSans; font-style: normal; font-weight: normal; src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\).eot\"); src: url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\).eot?#iefix\") format(\"embedded-opentype\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\).woff2\") format(\"woff2\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\).woff\") format(\"woff\"), url(\"./fonts/iran-sans/IRANSansWeb\\(FaNum\\).ttf\") format(\"truetype\"); } */\r\n@font-face {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: bold;\r\n\r\n  src: url(\"./fonts/inter/Inter-Bold.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  src: url(\"./fonts/inter/Inter-Medium.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  src: url(\"./fonts/inter/Inter-Light.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 200;\r\n  src: url(\"./fonts/inter/Inter-ExtraLight.ttf\") format(\"truetype\");\r\n}\r\n@font-face {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  src: url(\"./fonts/inter/Inter-Regular.ttf\") format(\"truetype\");\r\n}\r\n/* Vazirmatn */\r\n@font-face {\r\n  font-family: Vazirmatn;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src: url(\"./fonts/vazirmatn-v16-latin/vazirmatn-v16-latin-regular.woff2\") format(\"woff2\");\r\n}\r\n\r\n/* Noto Nastaliq Urdu */\r\n@font-face {\r\n  font-family: \"Noto Nastaliq Urdu\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src: url(\"./fonts/noto-nastaliq-urdu-v23-latin/noto-nastaliq-urdu-v23-latin-regular.woff2\")\r\n    format(\"woff2\");\r\n}\r\n\r\n/* Markazi Text */\r\n@font-face {\r\n  font-family: \"Markazi Text\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src: url(\"./fonts/markazi-text-v28-latin/markazi-text-v28-latin-regular.woff2\") format(\"woff2\");\r\n}\r\n\r\n/* Lalezar */\r\n@font-face {\r\n  font-family: Lalezar;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  src: url(\"./fonts/lalezar-v16-latin/lalezar-v16-latin-regular.woff2\") format(\"woff2\");\r\n}\r\nhtml,\r\nbody {\r\n  width: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\nbody {\r\n  direction: rtl;\r\n  font-family: Estedad !important;\r\n  overflow-y: scroll;\r\n}\r\na {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n*:not(.Toastify__toast-body, body) {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  /* font-family: inherit !important; */\r\n  font-family: Estedad !important;\r\n}\r\ndiv:focus-visible {\r\n  outline: none;\r\n}\r\nbutton,\r\ntextarea {\r\n  outline: none;\r\n  border: none;\r\n  background-color: transparent;\r\n}\r\ninput[type=\"radio\"] {\r\n  cursor: pointer;\r\n}\r\ninput {\r\n  border: none;\r\n  direction: inherit !important;\r\n}\r\ninput[type=\"text\"] {\r\n  outline: none;\r\n}\r\ninput[type=\"checkbox\"] {\r\n  /* Hide the default checkbox */\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 25px;\r\n  height: 25px;\r\n  border: 2px solid #777777;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\ninput[type=\"checkbox\"]:checked {\r\n  /* background-color: #007bff;  */\r\n  border: none;\r\n  position: relative;\r\n  font-family: Estedad !important;\r\n  background-color: var(--focused-input-color);\r\n}\r\ninput[type=\"checkbox\"]:checked::after {\r\n  content: \"✓\";\r\n  /* color: white; */\r\n  color: #ffffff;\r\n  font-size: 15px;\r\n  font-weight: 1000;\r\n  position: absolute;\r\n  top: 54%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\ninput[type=\"checkbox\"]:disabled {\r\n  background-color: transparent;\r\n  border: 2px solid var(--disabled-input-label-color) !important;\r\n  cursor: default;\r\n}\r\ninput[type=\"checkbox\"]:disabled:checked::after {\r\n  content: \"✓\"; /* Custom checkmark */\r\n  color: var(--disabled-input-label-color);\r\n  /* border: 2px solid #777777; */\r\n  font-size: 15px;\r\n  font-weight: 1000;\r\n  position: absolute;\r\n  top: 57%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\ninput[type=\"number\"] {\r\n  appearance: textfield;\r\n  -moz-appearance: textfield;\r\n}\r\ninput:disabled {\r\n  cursor: default;\r\n}\r\n.Toastify__toast-body {\r\n  text-align: right;\r\n  font-family: Estedad;\r\n}\r\n.Toastify__toast-container {\r\n  z-index: 10010 !important;\r\n}\r\n.css-1h9z7r5-MuiButtonBase-root-MuiTab-root {\r\n  width: 100%;\r\n}\r\n.css-159ulw2-MuiPaper-root {\r\n  box-shadow: none !important;\r\n}\r\n.forceEn {\r\n  font-family: Inter;\r\n  direction: ltr;\r\n}\r\n.forcePe {\r\n  font-family: Estedad;\r\n  direction: rtl;\r\n}\r\n/* .css-1mqtfgo-MuiFormControlLabel-root {\r\n  width: max-content;\r\n} */\r\n\r\n@media all and (max-width: 480px) {\r\n  .Toastify__toast-body {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n@keyframes allSystemInAnimation {\r\n  0% {\r\n    /* opacity: 0;\r\n    visibility: hidden; */\r\n    transform: translateX(101%);\r\n  }\r\n  100% {\r\n    /* opacity: 1;\r\n    visibility: visible; */\r\n    transform: translateX(0);\r\n  }\r\n}\r\n@keyframes allSystemOutAnimation {\r\n  0% {\r\n    /* opacity: 1; */\r\n    transform: translateX(0);\r\n  }\r\n  100% {\r\n    /* opacity: 0;\r\n    visibility: hidden; */\r\n    transform: translateX(101%);\r\n  }\r\n}\r\n@keyframes selectedSystemInAnimation {\r\n  0% {\r\n    /* opacity: 0;\r\n    visibility: hidden; */\r\n    transform: translateX(101%);\r\n  }\r\n  100% {\r\n    /* opacity: 1;\r\n    visibility: visible; */\r\n    transform: translateX(0);\r\n  }\r\n}\r\n@keyframes selectedSystemIOutAnimation {\r\n  0% {\r\n    /* opacity: 1; */\r\n    transform: translateX(0);\r\n  }\r\n  100% {\r\n    /* opacity: 0;\r\n    visibility: hidden; */\r\n    transform: translateX(101%);\r\n  }\r\n}\r\n@media all and (max-width: 800px) {\r\n  .Toastify__toast-container--top-right {\r\n    right: 0 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
